import { Box, Switch, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { SearchBar } from 'src/components/input';
import { Progress } from 'src/components/progress';
import { DataTestID, lang } from 'src/utils';

import { SearchArea } from '../searchArea';
import { SearchBarWithBadgesProps } from './SearchBarWithBadges.interface';
import {
  ChipSpacer,
  SearchTerms,
  ToggleExactMatch,
} from './SearchBarWithBadges.styled';

export const SearchBarWithBadges = (props: SearchBarWithBadgesProps) => (
  <Box>
    {props.hasExactSearch && (
      <ToggleExactMatch>
        <Typography>{lang.exactMatch}</Typography>
        <Switch
          data-testid={DataTestID.ExactMatchToggle}
          checked={!props.isFuzzySearch}
          onChange={props.onSearchTypeChange}
        />
      </ToggleExactMatch>
    )}

    {props?.enableSearchArea ? (
      <SearchArea {...props} />
    ) : (
      <SearchBar multiple {...props} />
    )}

    {!isEmpty(props.searchTerms) && (
      <Box position="relative">
        <SearchTerms>
          {[...new Set(props.searchTerms)].map((term) => {
            const match = props.matchedNames?.find((m) => m.name === term);
            const isMatched = !props.isFuzzySearch
              ? match?.matched ?? true
              : true;

            const containsEscapedBackslash = term.includes('\\\\');

            return isEmpty(term) ? null : (
              <ChipSpacer key={term}>
                <DynamicTooltipChip
                  tooltipWidth={500}
                  tooltipActivationWidth={252}
                  tooltipPlacement="right"
                  tooltipTitle={term}
                  chipName={term}
                  onDelete={props.onRemoveTerm}
                  replaceSpaces={true}
                  removeBackslashes={true}
                  containsEscapedBackslash={containsEscapedBackslash}
                  isMatched={isMatched}
                />
              </ChipSpacer>
            );
          })}
        </SearchTerms>
        {props.isLoading && !props.isFuzzySearch && (
          <Box
            data-testid={DataTestID.SearchBarLoading}
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            zIndex={10}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255,255,255,0.6)">
            <Progress />
          </Box>
        )}
      </Box>
    )}
  </Box>
);
